import { StaticImageData } from 'next/image'

import norwoodScale2 from '@/images/treatments/quiz/hair-loss/norwood-stage-2.gif'
import norwoodScale3 from '@/images/treatments/quiz/hair-loss/norwood-stage-3.gif'
import norwoodScale4 from '@/images/treatments/quiz/hair-loss/norwood-stage-4.gif'
import norwoodScale5 from '@/images/treatments/quiz/hair-loss/norwood-stage-5.gif'
import norwoodScale6 from '@/images/treatments/quiz/hair-loss/norwood-stage-6.gif'
import norwoodScale7 from '@/images/treatments/quiz/hair-loss/norwood-stage-7.gif'

export type Image = {
  data: StaticImageData
  ratio: '3x2'
}

export const ImageMap: Record<string, Image> = {
  norwood_scale_2: {
    data: norwoodScale2,
    ratio: '3x2',
  },
  norwood_scale_3: {
    data: norwoodScale3,
    ratio: '3x2',
  },
  norwood_scale_4: {
    data: norwoodScale4,
    ratio: '3x2',
  },
  norwood_scale_5: {
    data: norwoodScale5,
    ratio: '3x2',
  },
  norwood_scale_6: {
    data: norwoodScale6,
    ratio: '3x2',
  },
  norwood_scale_7: {
    data: norwoodScale7,
    ratio: '3x2',
  },
}
